import styled, { css } from 'styled-components'

import { withBorder } from '@/theme/utils'

export const Section = styled.section(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['24']};
    padding: ${withBorder(theme, 16)};
    border: ${theme.border.size['1']} solid ${theme.colors.gray300};
    border-radius: ${theme.border.radius['12']};
    background: ${theme.colors.white};
  `,
)
